//this is for subscribed platforms
import { createContext } from "react";

const userContext = createContext();

export default userContext;